module.exports = __webpack_public_path__ + "img/img3.5fa99b62.jpg";